/**
 * 订单状态
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2020/10/10      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */
import React from "react";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import { Timeline } from "antd";
import "./index.less";
class OrderStatus extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            //是否展示更多
            isShowMore: false,
            //数据源
            list: [],
        };
    }

    /**
     * 获取数据
     */
    getData() {
        $.ajax({
            url: "/mg/po/essa-one/trackMg",
            type: "post",
            dataType: "json",
            contentType: "application/json",
            data: JSON.stringify({
                orderId: this.props.poId,
                //单据类型 1,PO单：1
                type: this.props.type || "1",
            }),
            success: (res) => {
                if (res.success && res.valid) {
                    const list = res.models || []
                    list.forEach((item={},inx)=>{
                        item.color = inx==0? "red":"grey";
                        item.children = (<> {item.trackTime?<span className={"mr_6"}>
                            {dayjs(item.trackTime).format("YYYY-MM-DD")}
                            <span className={"ml_4"}>{dayjs(item.trackTime).format("HH:mm")}</span>
                        </span>:"-"} {item.trackDesc}</>)
                    })
                    this.handleMore(this.state.isShowMore,list)
                    this.setState({
                        list: res.models || [],
                    });
                }
            },
        });
    }

    showMore() {
        const { isShowMore, list, } = this.state;
        const flag = !isShowMore
       this.handleMore(flag,list)
        this.setState({
            isShowMore:flag,
        });
    }
    // flag 是否展示
    handleMore(flag,list){
        let newList = []
        if(!flag&&list.length>2){
            list.forEach((item,inx)=> {
                if (inx < 2) {
                    newList.push(item)
                }
            })
        }else {
            newList = [...list]
        }
        this.setState({
            newList:newList
        });
    }
    componentDidMount() {
        this.getData();
    }

    render() {
        const { list, isShowMore,newList } = this.state;
        // const short = list.lenght>2?list.splice(0,2)
        // console.log("short",short)

        return (
            <div
                className="order-status-wrap"
                style={{ display: list.length ? "block" : "none" }}
            >
                <Timeline
                    items={newList||list}
                />
                {/*<ul>*/}
                    {/*{list.map(function (item, index) {*/}
                        {/*if (index <= 2 || isShowMore) {*/}
                            {/*return (*/}
                                {/*<Timeline.Item key={index}*/}
                                    {/*dot={*/}
                                        {/*<i*/}
                                            {/*className={*/}
                                                {/*index === 0*/}
                                                    {/*? "iconfont icon-gou"*/}
                                                    {/*: ""*/}
                                            {/*}*/}
                                        {/*></i>*/}
                                    {/*}*/}
                                    {/*color="red"*/}
                                {/*>*/}
                                    {/*<span className="margin-right-30">*/}
                                        {/*{dayjs(item.trackTime).format(*/}
                                            {/*"YYYY-MM-DD"*/}
                                        {/*)}*/}
                                    {/*</span>*/}
                                    {/*<span className="margin-right-30">*/}
                                        {/*{dayjs(item.trackTime).format("HH:mm")}*/}
                                    {/*</span>*/}
                                    {/*<span>{item.trackDesc}</span>*/}
                                {/*</Timeline.Item>*/}
                            {/*);*/}
                        {/*} else {*/}
                            {/*return null;*/}
                        {/*}*/}
                    {/*})}*/}
                {/*</ul>*/}
                <div
                    className="text-center"
                    style={{ display: list.length > 2 ? "block" : "none" }}
                >
                    <a className="blueBtn" onClick={this.showMore.bind(this)}>
                        <span>
                            {isShowMore
                                ? __getServerLanguage("ShouQiGengDuo")
                                : __getServerLanguage("ZhanShiGengDuo")}
                        </span>
                        <span
                            className={`${
                                isShowMore ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"
                            }`}
                        ></span>
                    </a>
                </div>
            </div>
        );
    }
}

OrderStatus.defaultProps = {
    //po id
    poId: "",
    //单据类型
    type: "1",
};

OrderStatus.propTypes = {
    poId: PropTypes.number,
    type: PropTypes.string,
};
export default OrderStatus;
